import SignIn from '../../components/Login/SignIn';
import themeAA from '../../../../assets/js/ThemeAA';
import { ThemeProvider } from '@mui/material/styles';
import ContextUsers from '../../components/Login/ContextUser/Actions'

const LoginModal = ({onCloseLoginModal, createAnfitrion, esTroya}) =>{
    return (
        <ThemeProvider theme={themeAA}>
            <ContextUsers>
                <SignIn esTroya={esTroya ? true : false}  createAnfitrion={createAnfitrion ? true : false} modalOpen={true} onCloseLoginModal={onCloseLoginModal}/>
            </ContextUsers>
        </ThemeProvider>
    )
};

export default LoginModal;